import { useContext } from 'react';
import { SelectedParamContext, SetSelectedParamContext } from './Provider';

export const useSelectedParam = () => useContext(SelectedParamContext);
export const useSetSelectedParam = () => useContext(SetSelectedParamContext);
